module.exports = __webpack_public_path__ + "img/Vector.838f1e73.svg";